import { getAccessToken } from './authService';

/**
 * Fetches the signed-in user's profile photo from Microsoft Graph.
 * Returns a data URL string if successful, or undefined if not available.
 */
export async function fetchProfilePhoto(): Promise<string | undefined> {
  try {
    const accessToken = await getAccessToken(["User.Read"]);
    const response = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    if (!response.ok) return undefined;
    const blob = await response.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.warn("Could not fetch profile photo from Graph:", err);
    return undefined;
  }
}
